import React, { createContext, useContext, useMemo } from "react";

export interface ExportPollingContextValue {
  isExporting: boolean;
  elapsedSeconds: number;
}

const ExportPollingContext = createContext<ExportPollingContextValue>({
  isExporting: false,
  elapsedSeconds: 0,
});

export const useExportPollingContext = (): ExportPollingContextValue =>
  useContext(ExportPollingContext);

export const ExportPollingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const contextValue = useMemo(
    () => ({ isExporting: false, elapsedSeconds: 0 }),
    []
  );

  return (
    <ExportPollingContext.Provider value={contextValue}>
      {children}
    </ExportPollingContext.Provider>
  );
};
